import { Page, View, Text, Image } from "@react-pdf/renderer";
import type { FC, ReactNode } from "react";
import styles from "./pdfStyles";
import { colors, fontSize as fs, FONT_FAMILY } from "./pdfTokens";

interface PdfPageWrapperProps {
  children: ReactNode;
  logoSrc?: string | null;
}

const formatDate = () => {
  const d = new Date();
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

const date = formatDate();

const logoFallbackStyle = {
  fontFamily: FONT_FAMILY,
  fontSize: fs.titleMd,
  fontWeight: 700 as const,
  color: colors.accentGreen,
  letterSpacing: 1,
};

export const PdfPageWrapper: FC<PdfPageWrapperProps> = ({ children, logoSrc }) => (
  <Page size="A4" style={styles.page}>
    <View style={styles.headerFixed} fixed>
      {logoSrc ? (
        <Image src={logoSrc} style={styles.headerLogo} />
      ) : (
        <Text style={logoFallbackStyle}>MEP</Text>
      )}
      <Text style={styles.headerDate}>{date}</Text>
    </View>

    {children}

    <View style={styles.footerFixed} fixed>
      <Text style={styles.footerText}>
        Generated by AIMES Trustworthy Decision Intelligence Platform.
        Confidential. {date}
      </Text>
    </View>
  </Page>
);
